module.exports = __webpack_public_path__ + "static/media/OSHA.fe332f1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/OSHA.svg
// module id = 76
// module chunks = 0